"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var AuthIntroSection_1 = __importDefault(require("containers/Authentication/AuthIntroSection"));
var hooks_1 = require("containers/Authentication/hooks");
var LayoutCenter_1 = __importDefault(require("containers/Authentication/styles/LayoutCenter"));
var StyledGrid_1 = __importDefault(require("containers/Authentication/styles/StyledGrid"));
var LoginLink_1 = __importDefault(require("../Login/LoginLink"));
var SignUpForm_1 = __importDefault(require("./SignUpForm"));
var utils_1 = require("./utils");
var SignUp = function () {
    (0, hooks_1.useRedirectIfAuth)(true);
    var titleDesc = (0, utils_1.getTitleDescForSignUp)();
    if (!titleDesc) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, __assign({ title: titleDesc.headerMeta.title, description: titleDesc.headerMeta.desc }, { children: (0, jsx_runtime_1.jsx)("meta", { name: "robots", content: "noindex,nofollow" }) })), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsxs)(LayoutCenter_1.default, { children: [(0, jsx_runtime_1.jsxs)(StyledGrid_1.default, __assign({ container: true, spacing: 4, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(AuthIntroSection_1.default, { welcomeMsg: titleDesc.welcomeMsg, description: ((0, jsx_runtime_1.jsx)("ul", { children: titleDesc.descriptionPoints.map(function (msg) { return (0, jsx_runtime_1.jsx)("li", { children: msg }, msg); }) })) }), (0, jsx_runtime_1.jsx)(SignUpForm_1.default, {})] })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mt: 4, mb: 1.5 }, { children: (0, jsx_runtime_1.jsx)(LoginLink_1.default, { description: "Already signed up?", linkLabel: "Log in" }) }))] }) })] }));
};
exports.default = SignUp;
